// Task and Reservation statuses
const RINGING = "ASSIGNED"
const ANSWERED = "ACTIVE"

const ACCEPTED = "ACCEPTED"
const COMPLETED = "COMPLETED"
const TIMED_OUT = "TIMED_OUT"
const CANCELLED = "CANCELLED"

const RESERVATION_STATUS = {
  ACCEPTED,
  COMPLETED,
  TIMED_OUT,
  CANCELLED,
  RINGING,
}

const TASK_STATUS = {
  RINGING,
  ANSWERED,
}

const VIDEO = "VIDEO"
const AUDIO = "AUDIO"

// An end event whose payload lists no tasks means the agent owns none. That is also what an idle
// or login snapshot looks like, so it says nothing about a call someone else is monitoring.
const isEmptyTaskSnapshot = (serverPayload) => serverPayload?.tasks?.length === 0

module.exports = {
  isEmptyTaskSnapshot,
  RESERVATION_STATUS,
  TASK_STATUS,
  VIDEO,
  AUDIO,
}
